import axios from '@_system/axios/axios.js'
export default {
	path: '/reconciliationbill',
	list(data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	save(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	get(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	update(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.put(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	delete(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.delete(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	getunsettlementbill(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/getunsettlementbill/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},

	sendBilltask(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/sendBilltask', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},

	createBill(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/createBill/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},

	saveBill(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/saveBill/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	addfinbill(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/addfinbill/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	closefinbill(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/closefinbill/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	repairfinbill(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/repairfinbill/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	
	
	download(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/download', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	autocheck(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/autocheck', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	statistics(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/statistics', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	downloadprinttemplate(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/downloadprinttemplate', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	checkunderline(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/checkunderline', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},



	init(data = {}) {
		return new Promise((resolve, reject) => {
			axios.get('moduleConfig/admin/reconciliationbill.reconciliationbill', data, (res) => {
				resolve(res.data)
			}, reject, true)
		})
	},

	// saleorderimport(id, data = {}) {
	// 	return new Promise((resolve) => {
	// 		axios.post(this.path + '/saleorderimport/' + id, data, (res) => {
	// 			resolve(res.data)
	// 		})
	// 	})
	// },
	// saleorderexport(data = {}) {
	// 	return new Promise((resolve) => {
	// 		axios.post(this.path + '/saleorderexport', data, (res) => {
	// 			resolve(res.data)
	// 		})
	// 	})
	// },
}